import React from "react";
import Content from "../../content-interface";
import Accordion from "../accordion/Accordion";

const Principles = (props: {
  principles: Content['principles'],
  openPrincipleId?: string,
}) => {
  const {principles} = props;

  return (
    <div className="Principles">
      {Object.keys(principles).length > 0 ? <Accordion
        openIndex={props.openPrincipleId !== undefined ? Object.keys(principles).findIndex(principleId => principleId === props.openPrincipleId) : undefined}
        lightTheme={true}
        items={
          Object.keys(principles)
            .map(principleId => ({
              title: `Principle ${principleId}`,
              htmlContent: `<h5>${principles[principleId].title}</h5>${principles[principleId].htmlContent}`
            }))
        }/> : 'No matching principles'}
    </div>
  );
}

export default Principles;
